var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LeadGenerationConfigurationService } from '../shared/services/lead-generation-configuration.service';
import { ActivatedRoute, Router } from '@angular/router';
import DeviceType from '../shared/domain/device.type';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { ValidateUniqueName } from '../projects/validators/projectUniqueName.validator';
import { ProjectsService } from '../projects/projects.service';
import { initialConfig } from '../shared/domain/initialConfig';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { getActiveProjectSelector, getCreatedProjectSnapshotSelector } from '../projects/projects.reducer';
import { CreateProjectAction, UpdateProjectConfigurationAction } from '../projects/projects.action';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { LanguageService } from '../../shared/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import rawDomainRegex from '../shared/regex/rawDomainRegex';
import { markFormAsTouched } from '../shared/reactive-forms/forEachElementInForm';
var SettingsComponent = /** @class */ (function () {
    function SettingsComponent(leadGenerationConfiguration, route, router, projectsService, amplitudeService, fb, store, toastr, crazyCallConfigService, languageService, translate) {
        var _this = this;
        this.leadGenerationConfiguration = leadGenerationConfiguration;
        this.route = route;
        this.router = router;
        this.projectsService = projectsService;
        this.amplitudeService = amplitudeService;
        this.fb = fb;
        this.store = store;
        this.toastr = toastr;
        this.crazyCallConfigService = crazyCallConfigService;
        this.languageService = languageService;
        this.translate = translate;
        this.displayConditionsFormWrapper = { form: null };
        this.workingHoursFormWrapper = { form: null };
        this.isSubmitted = false;
        this.account = route.snapshot.data['account'];
        this.deviceTypes = Object.values(DeviceType);
        this.isCodeInstalled = false;
        this.currentLanguage = this.languageService.getCookieLanguage();
        this.store.select(getActiveProjectSelector).subscribe(function (config) {
            if (config && config.projectId) {
                _this.config = config;
            }
            else {
                _this.config = initialConfig(_this.account, _this.currentLanguage || 'en');
                _this.creatingNewProject = true;
            }
        });
        this.store.select(getCreatedProjectSnapshotSelector).subscribe(function (config) {
            if (config) {
                _this.config = config;
            }
        });
    }
    SettingsComponent.prototype.ngOnInit = function () {
        this.logAmplitude('Init');
        this.initForms();
        this.fillForms();
        window.scroll(0, 0);
    };
    SettingsComponent.prototype.initForms = function () {
        var urlValidators = Validators.pattern(/.*?\..{2,}/);
        this.settingsForm = this.fb.group({
            name: [
                'WebCall Project',
                [Validators.required],
                ValidateUniqueName(this.projectsService, this.leadGenerationConfig.name)
            ],
            domainName: ['', Validators.pattern(rawDomainRegex)],
            allowSubdomains: [''],
            ignoreDisplayLimit: [''],
            displayOnDeviceType: [''],
            active: [''],
            timeBetweenShownPopups: [''],
            timeBetweenSubmittedPopups: [''],
            webhookUrl: ['', urlValidators]
        });
    };
    SettingsComponent.prototype.fillForms = function () {
        var _this = this;
        Object.entries(this.leadGenerationConfig).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (_this.settingsForm.controls.hasOwnProperty(key)) {
                _this.settingsForm.controls[key].setValue(value);
            }
        });
    };
    Object.defineProperty(SettingsComponent.prototype, "leadGenerationConfig", {
        get: function () {
            return this.config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsComponent.prototype, "installedCodeUrl", {
        get: function () {
            return this.config.domainName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsComponent.prototype, "popupLink", {
        get: function () {
            return (this.settingsForm.get('domainName').value +
                '?crazycall-open-dialog=true&crazycall-project=' +
                this.leadGenerationConfig.projectId);
        },
        enumerable: true,
        configurable: true
    });
    SettingsComponent.prototype.onSubmit = function () {
        if (!this.settingsForm.valid) {
            markFormAsTouched(this.settingsForm);
            return;
        }
        this.logAmplitude('Submit', this.mapFormValuesToConfig());
        this.isSubmitted = true;
        this.creatingNewProject ? this.createProject() : this.updateConfig();
    };
    SettingsComponent.prototype.createProject = function () {
        this.config = this.mapFormValuesToConfig();
        this.store.dispatch(new CreateProjectAction(this.config));
    };
    SettingsComponent.prototype.mapFormValuesToConfig = function (config) {
        if (config === void 0) { config = this.config; }
        return __assign({}, config, this.settingsForm.getRawValue(), { displayConditions: this.displayConditionsFormWrapper.form.get('displayConditions').value, workingHours: this.workingHoursFormWrapper.form.getRawValue() });
    };
    SettingsComponent.prototype.updateConfig = function () {
        this.config = this.mapFormValuesToConfig();
        this.store.dispatch(new UpdateProjectConfigurationAction(this.config));
    };
    SettingsComponent.prototype.isFormValid = function () {
        return (
        // this.settingsForm.valid &&
        (!this.displayConditionsFormWrapper.form || this.displayConditionsFormWrapper.form.valid) &&
            (!this.workingHoursFormWrapper.form ||
                this.workingHoursFormWrapper.form.valid ||
                !this.workingHoursFormWrapper.form.get('enabled').value));
    };
    SettingsComponent.prototype.logAmplitude = function (message, event) {
        this.amplitudeService.logEvent("Panel:WebCall:Settings: " + message, event);
    };
    return SettingsComponent;
}());
export { SettingsComponent };
